require('@/bootstrap')

import { createApp } from 'vue'
import App from '@/App.vue'
import store from '@/services/store/store.js'

const appElement = window.document.getElementById('event-widget')

if (appElement) {
    if (!appElement.dataset.apiDomain) {
        // eslint-disable-next-line no-console
        console.error('🧨', `'data-api-domain' attribute missing but required`)
    }

    window.axios.defaults.baseURL = appElement.dataset.apiDomain

    const app = createApp(App, {
        locationKey: appElement.dataset.locationKey,
        eventKey: appElement.dataset.eventKey,
        months: appElement.dataset.months,
    }).use(store)

    app.mount('#event-widget')
}
